import { Modal } from 'antd';
import styled from 'styled-components';

export const TemplateModalWrapper = styled(Modal)`
  .ant-btn {
    height: 40px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 12px;

    &:first-child {
      margin-left: 0;
    }
  }

  .cancel-button {
    background-color: transparent;
    border: 1px solid #d9d9d9;
    color: #333;

    &:hover {
      background-color: #f5f5f5;
      border-color: #d9d9d9;
      color: #333;
    }

    &:focus {
      background-color: transparent;
      border-color: #d9d9d9;
      color: #333;
      box-shadow: 0 0 0 2px rgba(217, 217, 217, 0.2);
    }
  }

  .btn-success {
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    color: white;

    &:hover {
      background-color: #0B2A1B;
      border-color: #0B2A1B;
      color: white;
      opacity: 0.9;
    }

    &:focus {
      background-color: #0B2A1B;
      border-color: #0B2A1B;
      color: white;
      box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.2);
    }

    &:disabled {
      background-color: #0B2A1B;
      border-color: #0B2A1B;
      color: white;
      opacity: 0.5;
    }
  }

  .customize-btn {
    background-color: transparent;
    border: 1px solid #0B2A1B;
    color: #0B2A1B;

    &:hover {
      background-color: #0B2A1B;
      border-color: #0B2A1B;
      color: white;
    }

    &:focus {
      background-color: transparent;
      border-color: #0B2A1B;
      color: #0B2A1B;
      box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.2);
    }

    &:disabled {
      background-color: transparent;
      border-color: #d9d9d9;
      color: #d9d9d9;
    }
  }
`;